import { graphql } from "react-relay";

export const webAppChromeCardFragments = {
  viewer: graphql`
    fragment WebAppChromeCard_viewer on Viewer {
      user {
        chromeExtensionFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
      }
    }
  `,
};
